type ApiUrl = {
  sdcUrl: string;
};

const getApiUrl = (): ApiUrl => ({
  sdcUrl: process.env.REACT_APP_SDC_API_URL || '',
});

export default getApiUrl;
